import React, {Fragment, useMemo, useState} from 'react';
import {Button, Col, Row} from 'antd';
import {connect} from 'react-redux';
import {compose} from 'redux';
import {translate} from 'react-i18next';
import {GUTTER_SM, MARGIN_MD} from '../../../../../styles/constants';
import MappingSetMappingComponentList from "./MappingSetMappingComponentList";
import {
    addAllMappingSetWizardComponentMapperComponent,
    addMappingSetWizardComponentMapperComponent,
    removeAllMappingSetWizardComponentMapperComponent,
    removeMappingSetWizardComponentMapperComponent,
    selectMappingSetWizardComponentMapperComponent,
    stashMappingSetWizardComponentMapperComponent,
    hideTimeMappingAlert
} from "../actions";
import Transcoding01Alert from "./Transcoding01Alert";
import { Modal } from 'antd';
import Call from '../../../../../hocs/call';

const mapStateToProps = state => ({
    components: state.scenes.mappingHandler.mappingSet.wizard.components,
    selectedColumnName: state.scenes.mappingHandler.mappingSet.wizard.selectedColumnName,
    selectedDsdColumnName: state.scenes.mappingHandler.mappingSet.wizard.selectedDsdColumnName,
    selectedMapping: state.scenes.mappingHandler.mappingSet.wizard.selectedMapping,
    dsd: state.scenes.mappingHandler.mappingSet.wizard.dsd,
    selectedDataset: state.scenes.mappingHandler.mappingSet.wizard.selectedDataset,
    singleColumn: state.config.dataManagement.singleColumn,
    showMappingAlert: state.scenes.mappingHandler.mappingSet.wizard.showMappingAlert,
});

const mapDispatchToProps = dispatch => ({
    onComponentAdd: (singleColumn, constantValue) =>
        dispatch(addMappingSetWizardComponentMapperComponent(singleColumn, constantValue)),
    onComponentAddAll: () =>
        dispatch(addAllMappingSetWizardComponentMapperComponent()),
    onComponentRemove: (columnName, cubeComponentCode) =>
        dispatch(removeMappingSetWizardComponentMapperComponent(columnName, cubeComponentCode)),
    onComponentRemoveAll: () =>
        dispatch(removeAllMappingSetWizardComponentMapperComponent()),
    onComponentSelect: (mapping) =>
        dispatch(selectMappingSetWizardComponentMapperComponent(mapping)),
    onComponentStash: () => dispatch(stashMappingSetWizardComponentMapperComponent()),
    onAlertHide: () => dispatch(hideTimeMappingAlert()),
});

const MappingSetWizardComponentMapper = ({
                                             t,
                                             components,
                                             selectedDsdColumnName,
                                             selectedColumnName,
                                             selectedMapping,
                                             dsd,
                                             selectedDataset,
                                             onComponentAdd,
                                             onComponentAddAll,
                                             onComponentRemove,
                                             onComponentRemoveAll,
                                             onComponentSelect,
                                             onComponentStash,
                                             onAlertHide,
                                             singleColumn,
                                             showMappingAlert,
                                         }) => {
    const [constantValueAlertIsVisible, setConstantValueAlertIsVisible] = useState(false);
    const is01Mapping = useMemo(() => {
        return !!selectedDsdColumnName && (!selectedColumnName || selectedColumnName.length === 0);
    }, [selectedColumnName, selectedDsdColumnName]);

    return (
        <Fragment>
            <Row type="flex" justify="space-between" style={{marginBottom: MARGIN_MD}}>
            <Call
              cb={() => Modal.error({
                title: t('scenes.mappingHandler.MappingSet.wizard.steps.second.componentMapper.timeMappingAlertModal.title'),
                content: t('scenes.mappingHandler.MappingSet.wizard.steps.second.componentMapper.timeMappingAlertModal.content'),
                onOk() {
                    onAlertHide()
                },
                onCancel() {
                    onAlertHide()
                }
              })}
              disabled={!showMappingAlert}
            >
                <span></span>
            </Call>
                <Col>
                    <Row type="flex" gutter={GUTTER_SM}>
                        <Col>
                            <Button
                                onClick={() => is01Mapping ? setConstantValueAlertIsVisible(true) : onComponentAdd(singleColumn)}
                                disabled={!selectedDsdColumnName}
                                title={t('scenes.mappingHandler.MappingSet.wizard.steps.second.componentMapper.componentAddButton.title')}
                                icon="plus"
                            />
                        </Col>
                        <Col>
                            <Button
                                onClick={onComponentAddAll}
                                disabled={!dsd || !selectedDataset || !selectedDataset.columns}
                                title={t('scenes.mappingHandler.MappingSet.wizard.steps.second.componentMapper.componentAddAllButton.title')}
                                style={{
                                    'paddingLeft': 6,
                                    'paddingRight': 6,
                                    'fontSize': 22
                                }}
                            >
                                ++
                            </Button>
                        </Col>
                        <Col>
                            <Button
                                onClick={() => selectedMapping
                                    ? onComponentRemove(selectedMapping.columnName, selectedMapping.dsdColumnName)
                                    : null
                                }
                                disabled={!selectedMapping}
                                icon="minus"
                                title={t('scenes.mappingHandler.MappingSet.wizard.steps.second.componentMapper.componentRemoveButton.title')}
                            />
                        </Col>
                        <Col>
                            <Button
                                type="primary"
                                onClick={() => selectedMapping
                                    ? onComponentStash()
                                    : null
                                }
                                disabled={!components || components.length === 0}
                                icon="caret-down"
                                title={t('scenes.mappingHandler.MappingSet.wizard.steps.second.componentMapper.componentStashButton.title')}
                            />
                        </Col>
                    </Row>
                </Col>
                <Col className="file-mapping__file-mapping__wizardjoined__icons">
                    <Button
                        disabled={(components || []).length === 0}
                        onClick={() => onComponentRemoveAll()}
                        icon="delete"
                        title={t('scenes.mappingHandler.MappingSet.wizard.steps.second.componentMapper.componentRemoveAllButton.title')}
                    />
                </Col>
            </Row>
            <Transcoding01Alert onHideTranscodingSettingsState={() => setConstantValueAlertIsVisible(false)} showTranscodingSettings={constantValueAlertIsVisible} callback={(constantValue) => onComponentAdd(singleColumn, constantValue)} />
            <MappingSetMappingComponentList
                mappings={components}
                selectedMapping={selectedMapping ? selectedMapping : null}
                onSelect={(mapping) => onComponentSelect(mapping)}
                columnNameKey="columnName"
                dsdColumnNameKey="dsdColumnName"
            />
        </Fragment>
    )
}

export default compose(
    translate(),
    connect(mapStateToProps, mapDispatchToProps)
)(MappingSetWizardComponentMapper);
